import React, { useState, useImperativeHandle } from "react";
import { Session } from "../../../index.js";
import gameIndex from "../../../../common/gameIndex.js";
import { C, BORDER, Logo, GameSideMenu } from "../GameMenu.js";

// ── Overlay (scoreboard header + side menu) ────────────────────────────────────
function Overlay({ sessionId }, ref) {
	const session = Session.get(sessionId);
	const meta = gameIndex[session.slug] ?? {};
	const gameName = meta.name ?? session.slug;
	const instructions = meta.instructions ?? "";
	const showScores = meta.showScores ?? true;
	const activeModifiers = (meta.modifiers ?? []).filter((m) => session?.modifierIds?.includes(m.id));

	function initialDetail() {
		const registry = session?.state?.registry ?? {};
		return Object.keys(session?.players ?? {}).map((playerId) => ({
			playerId,
			score: registry[playerId]?.score ?? registry[playerId]?.points ?? 0,
		}));
	}

	const [menuOpen, setMenuOpen] = useState(false);
	const [detail, setDetail] = useState(initialDetail);

	useImperativeHandle(ref, () => ({
		setDetail: (newDetail) => setDetail(newDetail),
	}));

	return (
		<div style={{ position: "relative", fontFamily: "system-ui, sans-serif" }}>
			{menuOpen && (
				<GameSideMenu
					gameName={gameName}
					instructions={instructions}
					modifiers={activeModifiers}
					onClose={() => setMenuOpen(false)}
				/>
			)}

			{/* Title row — wordmark + menu button */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					padding: "12px 16px",
					background: C.bg,
					borderBottom: BORDER,
				}}
			>
				<Logo />
				<button
					onClick={() => setMenuOpen((o) => !o)}
					aria-label="Menu"
					style={{
						background: "transparent",
						border: "none",
						color: C.textSec,
						cursor: "pointer",
						padding: 4,
						fontSize: 24,
						lineHeight: 1,
					}}
				>
					+
				</button>
			</div>

			{/* Score strip — player chips */}
			{showScores && (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						background: C.surface,
						borderBottom: BORDER,
						overflowX: "auto",
						scrollbarWidth: "none",
						padding: "6px 14px",
						gap: 16,
					}}
				>
					{detail.map((item) => {
						const player = session.players[item.playerId];
						const color = player?.color ?? C.chrome;
						return (
							<div
								key={item.playerId}
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									gap: 3,
									flexShrink: 0,
									minWidth: 48,
								}}
							>
								<span
									style={{
										color,
										fontSize: 11,
										fontWeight: 600,
										maxWidth: 64,
										overflow: "hidden",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap",
									}}
								>
									{player?.name ?? "?"}
								</span>
								<span
									style={{
										color,
										background: `${color}26`,
										border: `1px solid ${color}50`,
										borderRadius: 4,
										padding: "1px 7px",
										fontSize: 12,
										fontWeight: 700,
									}}
								>
									{item.score}
								</span>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
}

export default React.forwardRef(Overlay);
